type QueryValue = string | number | boolean | null | undefined;

function basePath(workspaceId: string): string {
  return `/api/workspace/${encodeURIComponent(workspaceId)}/workflow`;
}

function withQuery(
  path: string,
  query?: Readonly<Record<string, QueryValue>>
): string {
  if (!query) return path;

  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === null || value === undefined || value === '') continue;
    params.set(key, String(value));
  }

  const search = params.toString();
  return search ? `${path}?${search}` : path;
}

export const workflowWorkspaceRoutes = {
  logs(
    workspaceId: string,
    query?: Readonly<{
      blockId?: string;
      status?: string;
      limit?: number;
      offset?: number;
    }>
  ): string {
    return withQuery(`${basePath(workspaceId)}/logs`, query);
  },

  blockLogs(
    workspaceId: string,
    blockId: string,
    query?: Readonly<{ limit?: number }>
  ): string {
    return withQuery(
      `${basePath(workspaceId)}/logs/${encodeURIComponent(blockId)}`,
      query
    );
  },

  log(workspaceId: string, logId: string): string {
    return `${basePath(workspaceId)}/logs/${encodeURIComponent(logId)}`;
  },

  blockLogCollection(workspaceId: string, blockId: string): string {
    return `${basePath(workspaceId)}/logs/block/${encodeURIComponent(blockId)}`;
  },

  pendingDecisions(workspaceId: string): string {
    return `${basePath(workspaceId)}/pending-decisions`;
  },

  resolveDecision(workspaceId: string, decisionId: string): string {
    return `${basePath(workspaceId)}/pending-decisions/${encodeURIComponent(decisionId)}/resolve`;
  },

  skipDecision(workspaceId: string, decisionId: string): string {
    return `${basePath(workspaceId)}/pending-decisions/${encodeURIComponent(decisionId)}/skip`;
  },

  activity(workspaceId: string, days: number): string {
    return withQuery(`${basePath(workspaceId)}/activity`, { days });
  },

  cancel(workspaceId: string, blockId: string): string {
    return `${basePath(workspaceId)}/cancel/${encodeURIComponent(blockId)}`;
  },
};
